import { faFileCircleExclamation } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

function NotFound() {
  return (
    <div>
        <div className='jumbotron text-center bg-light border'>
            <FontAwesomeIcon icon={faFileCircleExclamation} fontSize={128} className='mb-5 text-danger'/>
            <h2>Page Not Found</h2>
            <p>The page you are looking for is not available.</p>
        </div>
        <div className='container'></div>
    </div>
  )
}

export default NotFound